import { useSearch } from 'academy-common-lib/features/search/hooks/useSearch';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { HubspotProductToolsSections } from '../search/searchConsts';
import { convertToSupportedLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
export const useOnboardingResources = ({
  contentTypes,
  productGroups,
  language,
  pageLength,
  offset = 0,
  skip = false
}) => {
  const expandedTools = productGroups === null || productGroups === void 0 ? void 0 : productGroups.flatMap(group => {
    var _HubspotProductToolsS;
    return (_HubspotProductToolsS = HubspotProductToolsSections[group]) !== null && _HubspotProductToolsS !== void 0 ? _HubspotProductToolsS : [];
  });
  const hubSpotSoftware = expandedTools && expandedTools.length > 0 ? expandedTools : undefined;

  // TODO(APGA-516): Add visibilityGroup filter once BE adds an onboarding-specific
  // visibility option to scope results to onboarding resources only.
  const variables = {
    languages: [convertToSupportedLanguage(language)],
    contentTypes,
    hubSpotSoftware,
    pageLength,
    shouldFilterDeprecated: true,
    offset: {
      cursor: offset
    }
  };
  const {
    searchResults,
    searchResultsLoading,
    searchResultsError,
    totalCount
  } = useSearch({
    variables,
    skip
  });
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(item => {
      const {
        id,
        contentType
      } = item;
      return {
        id,
        type: contentType === 'TEMPLATE' || contentType === 'EBOOK' ? 'LESSON' : contentType,
        language: 'language' in item ? item.language : undefined
      };
    })) || [],
    skip: !searchResults
  });
  return {
    resources: cardModels,
    loading: searchResultsLoading || cardModelsLoading,
    error: searchResultsError || cardModelsError,
    totalCount: totalCount || 0
  };
};